module.exports = __webpack_public_path__ + "static/media/keyvisual_login_medium.d6eb87e8.jpg";